module.exports = __webpack_public_path__ + "images/emoji/baby_symbol.6a1f853eee566e70b55e.png";